import "../css/topheader.css";

import {
    FaSearch,
    FaHeart,
    FaShoppingCart,
    FaMapMarkerAlt,
    FaUser,
    FaSignOutAlt,
    FaClipboardList,
} from "react-icons/fa";

import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";


function TopHeader() {

    const navigate = useNavigate();

    // ===============================
    // USER
    // ===============================

    const user = JSON.parse(
        localStorage.getItem("user")
    );


    // ===============================
    // STATES
    // ===============================

    const [cartCount, setCartCount] = useState(0);

    const [search, setSearch] = useState("");

    const [showStores, setShowStores] = useState(false);


    // ===============================
    // CART COUNT
    // ===============================

    useEffect(() => {

        if (!user) return;

        axios
            .get(`${API_URL}/cart-count/${user.id}`)
            .then((res) => {

                setCartCount(
                    res.data.count || 0
                );

            })
            .catch((err) => {

                console.log(
                    "Cart count error:",
                    err
                );

            });

    }, [user]);


    // ===============================
    // LOGOUT
    // ===============================

    const handleLogout = () => {

        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("user_id");
        localStorage.removeItem("name");
        localStorage.removeItem("email");
        localStorage.removeItem("role");

        alert("Logged out successfully!");

        navigate("/login");

        window.location.reload();

    };


    // ===============================
    // SEARCH
    // ===============================

    const handleSearch = () => {

        if (search.trim() === "") {
            return;
        }

        navigate(
            `/shop?search=${encodeURIComponent(search)}`
        );

    };


    // ===============================
    // OPEN ADMIN STORES
    // ===============================

    const openStore = (url) => {

        setShowStores(false);

        window.location.href = url;

    };


    // ===============================
    // JSX
    // ===============================

    return (

        <header className="top-header">


            {/* ===============================
                LOGO
            =============================== */}

            <div className="logo">

                <Link
                    to="/"
                    className="logo-link"
                >
                    SIPS LIQUOR
                </Link>

            </div>


            {/* ===============================
                SELECT STORE
            =============================== */}

            <div
                className="location"
                onClick={() =>
                    setShowStores(!showStores)
                }
            >

                <FaMapMarkerAlt />

                <span>
                    Select Store
                </span>


                {showStores && (

                    <div
                        className="store-dropdown"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >


                        {/* APPLE 2 */}

                        <button
                            type="button"
                            onClick={() =>
                                openStore(
                                    "https://apple2.shopat1stop.com/admin"
                                )
                            }
                        >
                            Apple 2
                        </button>


                        {/* SIP LIQUORS */}

                        <button
                            type="button"
                            onClick={() =>
                                openStore(
                                    "https://sipsliquor.shopat1stop.com/admin/dashboard"
                                )
                            }
                        >
                            SIP Liquors
                        </button>


                        {/* HRMS */}

                        <button
                            type="button"
                            onClick={() =>
                                openStore(
                                    "https://hrweb.suriworks.us/"
                                )
                            }
                        >
                            HRMS
                        </button>


                    </div>

                )}

            </div>


            {/* ===============================
                SEARCH
            =============================== */}

            <div className="search-box">

                <input
                    type="text"
                    placeholder="Search Whiskey, Wine, Beer..."
                    value={search}
                    onChange={(e) =>
                        setSearch(e.target.value)
                    }
                    onKeyDown={(e) => {

                        if (e.key === "Enter") {
                            handleSearch();
                        }

                    }}
                />


                <button
                    type="button"
                    onClick={handleSearch}
                >
                    <FaSearch />
                </button>

            </div>


            {/* ===============================
                HEADER ICONS
            =============================== */}

            <div className="header-icons">


                {/* ===============================
                    LOGGED IN USER
                =============================== */}

                {user ? (

                    <>

                        <span className="user-name">

                            <FaUser />

                            Hi, {user.first_name}

                        </span>


                        <Link to="/my-orders">

                            <FaClipboardList />

                            <span>
                                My Orders
                            </span>

                        </Link>


                        <button
                            className="logout-btn"
                            onClick={handleLogout}
                        >

                            <FaSignOutAlt />

                            Logout

                        </button>

                    </>

                ) : (

                    /* ===============================
                       NOT LOGGED IN
                    =============================== */

                    <>

                        <Link to="/login">

                            <FaUser />

                            <span>
                                Login
                            </span>

                        </Link>


                        <Link to="/register">

                            <FaUser />

                            <span>
                                Register
                            </span>

                        </Link>

                    </>

                )}


                {/* ===============================
                    WISHLIST
                =============================== */}

                <Link to="/wishlist">

                    <FaHeart />

                    <span>
                        Wishlist
                    </span>

                </Link>


                {/* ===============================
                    CART
                =============================== */}

                <Link to="/cart">

                    <FaShoppingCart />

                    <span>
                        Cart ({cartCount})
                    </span>

                </Link>


            </div>

        </header>

    );

}


export default TopHeader;